import { SurveillanceWorkspace } from './SurveillanceWorkspace'

/** Merged Surveillance — live Postgres or BQ archive via Bet Ticker Previous 7-day switch. */
export function SurveillancePage() {
  return <SurveillanceWorkspace />
}
